export interface HubspotObjectOption {
  display_name: string;
  value: string;
}
export const HubspotObjectOptions: HubspotObjectOption[] = [
  { display_name: 'Companies', value: 'companies' },
  { display_name: 'Calls', value: 'calls' },
  { display_name: 'Contacts', value: 'contacts' },
  { display_name: 'Feedback submissions', value: 'feedback_submissions' },
  { display_name: 'Deals', value: 'deals' },
  { display_name: 'Emails', value: 'emails' },
  { display_name: 'Meetings', value: 'meetings' },
  { display_name: 'Notes', value: 'Notes' },
  { display_name: 'Tasks', value: 'tasks' },
  { display_name: 'Products', value: 'products' },
  { display_name: 'Quotes', value: 'quotes' },
  { display_name: 'Tickets', value: 'tickets' },
];
